"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupFilter = void 0;
var react_1 = __importDefault(require("react"));
var functional_1 = require("../utils/functional");
var _COLUMNS = 2;
var _LEFT = 0;
var PopupFilter = /** @class */ (function (_super) {
    __extends(PopupFilter, _super);
    function PopupFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleOption = _this.toggleOption.bind(_this);
        return _this;
    }
    PopupFilter.prototype.render = function () {
        var _this = this;
        var options = this.props.options;
        var columns = this.props.columns ? this.props.columns : _COLUMNS;
        var left = this.props.left ? this.props.left : _LEFT;
        // calculate how many rows, based on the number of columns and options
        var numRows = Math.ceil(options.length / columns);
        var width = columns === 1 ? "" : "w-1/".concat(columns);
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "underline cursor-pointer select-none", onClick: function () { return _this.props.onFilterOpen(!_this.props.open); } }, this.props.title),
            this.props.open && (react_1.default.createElement("div", { className: "z-30 absolute bg-white shadow flex flex-col py-1", style: { top: 20, left: left, minWidth: 100, minHeight: 100 } }, (0, functional_1.range)(numRows).map(function (r) { return (react_1.default.createElement("div", { key: r, className: "relative font-bold flex" }, (0, functional_1.range)(r === numRows - 1 && options.length % columns !== 0
                ? options.length % columns
                : columns).map(function (c) {
                var option = options[r * columns + c];
                return (react_1.default.createElement("div", { key: option.key, className: "".concat(width, " m-1 px-4 py-2 text-center  cursor-pointer flex-grow\n ").concat(option.selected ? "bg-teal-light" : "hover:bg-grey-lighter"), onClick: function () { return _this.toggleOption(option); } }, option.value));
            }))); })))));
    };
    PopupFilter.prototype.toggleOption = function (option) {
        option.selected = !option.selected;
        this.props.onFilterChange(this.props.options);
    };
    return PopupFilter;
}(react_1.default.Component));
exports.PopupFilter = PopupFilter;
